/**
 * Pages SEO locales — contenus uniques par ville / intention (évite le duplicate pur).
 */
export const LOCAL_SEO_PAGES = {
  lens: {
    path: '/medecine-esthetique-lens',
    title: 'Médecine esthétique près de Lens — Cabinet à Rouvroy | MN',
    description:
      'Cabinet de médecine esthétique à Rouvroy, facilement accessible depuis Lens et l\'agglomération. Hydrafacial, lasers Fotona et Neauvia, mésothérapie, injections. Médecins diplômés, sur rendez-vous.',
    keywords:
      'médecine esthétique Lens, médecin esthétique près de Lens, hydrafacial Lens, laser esthétique Pas-de-Calais, cabinet Rouvroy',
    h1: 'Médecine esthétique près de Lens',
    subH1: 'Cabinet médical à Rouvroy — accès depuis Lens et l’agglomération',
    intro: [
      'Vous recherchez une médecine esthétique près de Lens ? Le cabinet MN Médecine Esthétique est installé à Rouvroy (Maison médicale, 90 rue Louis Daubenton), à quelques minutes de route de Lens et des communes limitrophes. Les consultations et actes sont réalisés par des médecins diplômés, dans un cadre encadré.',
      'Nous accueillons des patientes et patients venant de Lens, Liévin, Carvin ou du bassin minier pour des soins non chirurgicaux : Hydrafacial, lasers (Fotona SP Dynamis, Neauvia), mésothérapie, injections et protocoles personnalisés après évaluation médicale.',
    ],
    accessNote:
      'Accès : depuis Lens, empruntez les axes habituels vers Rouvroy (itinéraire conseillé via votre GPS ou Google Maps). Stationnement à proximité de la maison médicale.',
    faq: [
      {
        q: 'Le cabinet est-il facilement accessible depuis Lens ?',
        a: 'Oui. Rouvroy est proche de Lens ; de nombreux patients viennent depuis Lens et l’agglomération pour leurs rendez-vous au cabinet de la rue Louis Daubenton.',
      },
      {
        q: 'Quels soins proposez-vous pour les patients de Lens ?',
        a: 'Hydrafacial, lasers esthétiques (Fotona, Neauvia), mésothérapie, injections et autres actes de médecine esthétique, après consultation médicale et selon les indications.',
      },
      {
        q: 'Comment prendre rendez-vous depuis Lens ?',
        a: 'Contactez le cabinet au 06 85 95 10 05 ou par email ; les créneaux sont attribués sur rendez-vous.',
      },
    ],
  },
  lievin: {
    path: '/medecine-esthetique-lievin',
    title: 'Médecine esthétique près de Liévin — Cabinet à Rouvroy | MN',
    description:
      'Médecine esthétique à proximité de Liévin : cabinet à Rouvroy (62320). Lasers, Hydrafacial, mésothérapie, injections. Équipe médicale, rendez-vous sur mesure.',
    keywords:
      'médecine esthétique Liévin, hydrafacial Liévin, laser esthétique Liévin, cabinet médecine esthétique Rouvroy',
    h1: 'Médecine esthétique près de Liévin',
    subH1: 'Cabinet à Rouvroy — à quelques minutes de Liévin',
    intro: [
      'Liévin et Rouvroy font partie du même bassin de vie : beaucoup de nos patientes et patients habitent à Liévin et se rendent au cabinet MN Médecine Esthétique pour leurs soins de médecine esthétique, en toute discrétion et dans un cadre médical.',
      'Le cabinet propose notamment Hydrafacial, lasers haut de gamme (Fotona SP Dynamis, Neauvia), mésothérapie et injections, toujours après consultation et décision médicale. Une seule adresse : 90 rue Louis Daubenton, 62320 Rouvroy.',
    ],
    accessNote:
      'Trajet court entre Liévin et Rouvroy : prévoyez votre itinéraire via Maps ; le cabinet se situe en maison médicale.',
    faq: [
      {
        q: 'Puis-je venir de Liévin pour un Hydrafacial ?',
        a: 'Oui, après rendez-vous et évaluation médicale, les protocoles dont Hydrafacial sont proposés au cabinet de Rouvroy.',
      },
      {
        q: 'Y a-t-il un parking près du cabinet ?',
        a: 'Des possibilités de stationnement existent à proximité de la maison médicale ; renseignez-vous auprès du secrétariat si besoin.',
      },
    ],
  },
  henin: {
    path: '/medecine-esthetique-henin-beaumont',
    title: 'Médecine esthétique près de Hénin-Beaumont | Cabinet Rouvroy',
    description:
      'Patients de Hénin-Beaumont : cabinet de médecine esthétique à Rouvroy. Lasers, Hydrafacial, injections, mésothérapie. Médecins expérimentés, sur RDV.',
    keywords:
      'médecine esthétique Hénin-Beaumont, laser esthétique Hénin-Beaumont, hydrafacial près Hénin-Beaumont, Rouvroy',
    h1: 'Médecine esthétique près de Hénin-Beaumont',
    subH1: 'Rendez-vous au cabinet de Rouvroy',
    intro: [
      'Depuis Hénin-Beaumont et le Centre-bassin, le cabinet MN Médecine Esthétique à Rouvroy est un point de rendez-vous pour une médecine esthétique exigeante : technologies laser, soins de peau et actes injectables encadrés médicalement.',
      'Nous ne sommes pas une succursale : une seule adresse, une équipe médicale stable, pour des parcours de soin clairs. Les personnes venant d’Hénin-Beaumont bénéficient des mêmes protocoles que l’ensemble de nos patients du Pas-de-Calais.',
    ],
    accessNote:
      'Depuis Hénin-Beaumont, comptez un trajet routier vers Rouvroy (itinéraire GPS recommandé).',
    faq: [
      {
        q: 'Acceptez-vous les patients venant de Hénin-Beaumont ?',
        a: 'Oui, le cabinet accueille toute personne motivée par un parcours de médecine esthétique, sur rendez-vous.',
      },
    ],
  },
  hub: {
    path: '/medecine-esthetique-pas-de-calais',
    title: 'Médecine esthétique Hauts-de-France | Cabinet MN à Rouvroy',
    description:
      'Cabinet de médecine esthétique à Rouvroy (62320), dans les Hauts-de-France. Patients de Lens, Liévin, Arras, Douai, Béthune, Lille, Valenciennes et Dunkerque. Hydrafacial, lasers, injections. RDV.',
    keywords:
      'médecine esthétique Hauts-de-France, médecine esthétique Pas-de-Calais, médecine esthétique Nord, clinique esthétique Rouvroy Lens Liévin Lille, médecine esthétique bassin minier',
    h1: 'Médecine esthétique dans les Hauts-de-France',
    subH1: 'Cabinet à Rouvroy — zones desservies du Pas-de-Calais au Nord',
    intro: [
      'Le cabinet MN Médecine Esthétique est basé à Rouvroy (62320), au cœur des Hauts-de-France. Nous accueillons une patientèle venue de tout le bassin minier et plus largement de la région : Lens, Liévin, Hénin-Beaumont, Carvin, Avion, mais aussi Arras, Douai, Béthune, Lille, Valenciennes ou Dunkerque selon les projets de soin.',
      'Cette page centralise l’information géographique : le contenu médical détaillé se trouve sur la page d’accueil (soins, médecins, tarifs). Notre lieu d’exercice est unique (Rouvroy) ; nous sommes accessibles depuis les villes listées ci-dessous, du Pas-de-Calais au département du Nord.',
    ],
    citiesList: [
      'Lens',
      'Liévin',
      'Hénin-Beaumont',
      'Carvin',
      'Avion',
      'Arras',
      'Douai',
      'Béthune',
      'Lille',
      'Valenciennes',
      'Dunkerque',
      'Amiens',
    ],
    accessNote: null,
    faq: [
      {
        q: 'Pourquoi une seule adresse à Rouvroy ?',
        a: 'Nous sommes un cabinet médical avec un lieu d’exercice déclaré ; cela garantit la traçabilité des soins et la cohérence de l’équipe soignante.',
      },
      {
        q: 'Comment savoir si je suis concerné par vos soins ?',
        a: 'Une consultation médicale permet d’évaluer vos attentes et les contre-indications éventuelles avant tout protocole.',
      },
    ],
  },
  hydrafacial: {
    path: '/hydrafacial-lens-rouvroy',
    title: 'Hydrafacial près de Lens — Cabinet à Rouvroy | MN Médecine Esthétique',
    description:
      'Hydrafacial à Rouvroy, cabinet accessible depuis Lens et l’agglomération. Soin médical non invasif, sur rendez-vous. MN Médecine Esthétique.',
    keywords: 'hydrafacial Lens, hydrafacial Rouvroy, hydrafacial Pas-de-Calais, soin visage Lens',
    h1: 'Hydrafacial près de Lens',
    subH1: 'Réalisé au cabinet médical de Rouvroy',
    intro: [
      'Vous cherchez un Hydrafacial près de Lens ? Le protocole est proposé au cabinet MN Médecine Esthétique, 90 rue Louis Daubenton à Rouvroy, à courte distance de Lens pour de nombreux patients de l’agglomération.',
      'L’Hydrafacial est un soin de médecine esthétique non invasif combinant nettoyage, exfoliation, extraction et hydratation. Il est pratiqué dans un cadre médical, après analyse de votre peau et de vos objectifs. Pour les soins laser ou les injections, voir les sections dédiées sur la page d’accueil.',
    ],
    accessNote:
      'Depuis Lens, rejoignez Rouvroy en voiture (itinéraire GPS) ; le cabinet se situe en maison médicale.',
    faq: [
      {
        q: 'Hydrafacial : combien de séances depuis Lens ?',
        a: 'Le nombre de séances dépend de votre peau et de votre objectif ; le médecin vous indique un plan personnalisé en consultation.',
      },
      {
        q: 'Puis-je combiner Hydrafacial avec d’autres actes ?',
        a: 'Les associations possibles sont discutées au cas par cas lors de la consultation médicale.',
      },
    ],
  },
};

export const LOCAL_PAGE_KEYS = Object.keys(LOCAL_SEO_PAGES);
